var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.is_open)?_vm._t("short"):_vm._t("long"),_vm._v(" "),_vm._t("trigger",null,{"isOpen":_vm.is_open,"open":_vm.open,"close":_vm.close,"toggle":_vm.toggle})],2)}
var staticRenderFns = []

export { render, staticRenderFns }